import { find } from 'lodash';
import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  Dropdown,
  Container,
  SubForma,
  TablaMaestra,
  TextArea,
  BaseControl,
  Textbox,
  Custom,
} from '@app/shared';

@Injectable()
export class CheckListFormsService {
  constructor() { }

  /**
   * Crea el formulario de creacion o edicion de una lista de chequeo
   *
   * @param {*} template
   * @param {*} options
   * @param {SubForma} [formCheckList]
   * @returns {BaseControl<any>[]}
   * @memberof CheckListFormsService
   */
  getFormCheckList(template: any, options: any, formCheckList?: SubForma): BaseControl<any>[] {
    let nameColumnReq = '';
    let nameColumnOpt = '';
    if (
      formCheckList &&
      formCheckList.campos &&
      formCheckList.campos.length
    ) {
      let fieldReq = find(formCheckList.campos, f => f.tipo_campo.nombre === 'textarea');
      if (fieldReq) {
        nameColumnReq = fieldReq.label;
      }
      fieldReq = find(formCheckList.campos, f => f.tipo_campo.nombre === 'text');
      if (fieldReq) {
        nameColumnOpt = fieldReq.label;
      }
    }
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'txtNombre',
        label: 'Nombre de la lista de chequeo:',
        value: formCheckList ? formCheckList.nombre : '',
        order: 1,
        placeholder: 'Ingresar el nombre de la lista de chequeo',
        validations: {
          validators: [Validators.required],
        }
      }),
      new Textbox({
        key: 'txtAlias',
        label: 'Alias de la lista de chequeo:',
        value: formCheckList ? formCheckList.alias : '',
        describe: 'Nota: este alias se utiliza como referencia para poder acceder a la lista de chequeo ' +
                  'y no debe llevar espacios ni caracteres especiales.',
        order: 2,
        placeholder: 'Ingresar el alias de la asociacion que contiene la forma',
        validations: {
          validators: [Validators.required, Validators.pattern('^[a-zA-Z_]*$')],
          messages: {pattern: 'Caracteres invalidos: solo letras y guiones bajos'}
        }
      }),
      new Textbox({
        key: 'txtNombreColumnaRequisitos',
        label: 'Nombre de la columna requisitos:',
        value: nameColumnReq ? nameColumnReq : 'Requisitos',
        describe: 'Nota: Este nombre se mostrara como titulo de la columna de descripción del requerimiento',
        order: 3,
        placeholder: 'Ingresar el nombre de la columna requisitos',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'txtNombreColumnaOpciones',
        label: 'Nombre de la columna de opciones:',
        value: nameColumnOpt ? nameColumnOpt : 'Sí / No / No Aplica',
        describe: 'Nota: Este nombre se mostrara como titulo de la columna de opciones de los requerimientos',
        order: 4,
        placeholder: 'Ingresar el nombre de la columna opciones',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Dropdown({
        key: 'cboTipoCarga',
        label: 'Fuente de datos:',
        options: [
          {key: 'TablaMaestra', value: 'Tabla Maestra'},
          {key: 'TablaForma', value: 'Tabla Forma'}
        ],
        value: formCheckList
                ? formCheckList.estilo['tipo']
                  ? formCheckList.estilo['tipo']
                  : 'TablaMaestra'
                : 'TablaMaestra',
        order: 5,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Container({
        class: 'form-row',
        order: 6,
        controls: [
          new Custom({
            key: 'cboMasterTable',
            label: 'Cargar información de la tabla Maestra:',
            template: template['templateNgSelect'],
            placeholder: 'Seleccione la tabla maestra de la carga de datos',
            options: this.setMasterTables(options['masterTables']),
            value: formCheckList
                    ? formCheckList.estilo['maestra']
                      ? formCheckList.estilo['maestra']
                      : null
                    : null,
            validations: {
              validators: [Validators.required]
            },
            size: 'col-12',
            condictions: [
              {
                campoDepende: 'cboTipoCarga',
                siEs: 'Igual',
                valor: 'TablaMaestra',
                accion: 'Mostrar'
              }
            ]
          }),
          new Custom({
            key: 'selectColumn',
            label: 'Columnas a mostrar de la maestra:',
            template: template['ngSelectColums'],
            placeholder: 'Columnas a mostrar de la maestra',
            value: formCheckList ?
                    formCheckList.estilo['columna_seleccionada'] ?
                      formCheckList.estilo['columna_seleccionada']
                    : null
                  : null,
            options: options['optionsSelectColum'] ? options['optionsSelectColum'] : [],
            validations: {
              validators: [Validators.required]
            },
            size: 'col-12',
            condictions: [
              {
                campoDepende: 'cboTipoCarga',
                siEs: 'Igual',
                valor: 'TablaMaestra',
                accion: 'Mostrar'
              }
            ]
          }),
          new Dropdown({
            key: 'cboForm',
            label: 'Forma de la tabla:',
            options: options ? options['forms'] ? options['forms'] : [] : [],
            value: formCheckList
                    ? formCheckList.estilo['cargar_tabla']
                      ? formCheckList.estilo['cargar_tabla']['form']
                        ? formCheckList.estilo['cargar_tabla']['form']
                        : null
                      : null
                    : null,
            validations: {
              validators: [Validators.required]
            },
            size: 'col-12',
            condictions: [
              {
                campoDepende: 'cboTipoCarga',
                siEs: 'Igual',
                valor: 'TablaForma',
                accion: 'Mostrar'
              }
            ]
          }),
          new Custom({
            key: 'cboFormulario',
            label: 'Cargar información de la tabla:',
            template: template['templateNgSelect'],
            placeholder: 'Seleccionar el formulario de la forma',
            options: options ? options['formularios'] ? options['formularios'] : [] : [],
            value: formCheckList
                    ? formCheckList.estilo['cargar_tabla']
                      ? formCheckList.estilo['cargar_tabla']['formulario']
                        ? formCheckList.estilo['cargar_tabla']['formulario']
                        : null
                      : null
                    : null,
            validations: {
              validators: [Validators.required]
            },
            size: 'col-12',
            condictions: [
              {
                campoDepende: 'cboTipoCarga',
                siEs: 'Igual',
                valor: 'TablaForma',
                accion: 'Mostrar'
              }
            ]
          }),
          new Custom({
            key: 'cboColumn',
            label: 'Columnas a mostrar:',
            template: template['ngSelectColums'],
            placeholder: 'Seleccionar el campo del formulario',
            options: options ? options['columns'] ? options['columns'] : [] : [],
            value: formCheckList
                    ? formCheckList.estilo['cargar_tabla']
                      ? formCheckList.estilo['cargar_tabla']['column']
                        ? formCheckList.estilo['cargar_tabla']['column']
                        : null
                      : null
                    : null,
            validations: {
              validators: [Validators.required]
            },
            size: 'col-12',
            condictions: [
              {
                campoDepende: 'cboTipoCarga',
                siEs: 'Igual',
                valor: 'TablaForma',
                accion: 'Mostrar'
              }
            ]
          }),
        ]
      }),
      new Container({
        class: 'form-row',
        order: 7,
        controls: [
          new Textbox({
            key: 'chOcultar',
            type: 'checkbox',
            value: formCheckList
                    ? formCheckList.estilo
                      ? formCheckList.estilo['ocultar_registros']
                        ? formCheckList.estilo['ocultar_registros']
                        : false
                      : false
                    : false,
            label: 'Ocultar registros bloqueados',
            size: 'col-3',
          }),
          new Textbox({
            key: 'chSincronizar',
            type: 'checkbox',
            value: formCheckList
                    ? formCheckList.estilo
                      ? formCheckList.estilo['sincronizado']
                        ? formCheckList.estilo['sincronizado']
                        : false
                      : false
                    : false,
            label: 'Sincronizar',
          }),
        ]
      }),
      new Textbox({
        key: 'txtAliasSincronizacion',
        label: 'Alias de la sincronizacion:',
        value: formCheckList
                ? formCheckList.estilo
                  ? formCheckList.estilo['aliasSincronizado']
                    ? formCheckList.estilo['aliasSincronizado']
                    : null
                  : null
                : null,
        order: 8,
        placeholder: 'Ingrese el alias con el cual se sincronizara la lista de chequeo',
        describe: 'Nota: este alias se utiliza como referencia para poder sincronizar ' +
                  'entre las otras lista de chequeo y no debe llevar espacios ni caracteres especiales.',
        validations: {
          validators: [Validators.required, Validators.pattern('^[a-zA-Z_]*$')],
          messages: {pattern: 'Caracteres invalidos: solo letras y guiones bajos'}
        },
        condictions: [
          {
            campoDepende: 'chSincronizar',
            siEs: 'Igual',
            valor: 'true',
            accion: 'Mostrar',
          }
        ]
      }),
      new Container({
        class: 'form-row',
        order: 6,
        controls: [
          new Custom({
            key: 'cboFormMultiple',
            label: 'Forma de la tabla ha vincular:',
            template: template['templateNgSelect'],
            options: options ? options['forms'] ? options['forms'] : [] : [],
            value: formCheckList
                    ? formCheckList.estilo['cargar_tabla']
                      ? formCheckList.estilo['cargar_tabla']['form']
                        ? formCheckList.estilo['cargar_tabla']['form']
                        : null
                      : null
                    : null,
            validations: {
              validators: []
            },
            size: 'col-12',
            condictions: [
              {
                campoDepende: 'cboTipoCarga',
                siEs: 'Igual',
                valor: 'TablaMaestra',
                accion: 'Mostrar'
              }
            ]
          }),
          new Custom({
            key: 'cboFormularioMultiple',
            label: 'Cargar información de la tabla:',
            template: template['templateNgSelect'],
            placeholder: 'Seleccionar el formulario de la forma:',
            options: options ? options['formularios'] ? options['formularios'] : [] : [],
            value: formCheckList
                    ? formCheckList.estilo['cargar_tabla']
                      ? formCheckList.estilo['cargar_tabla']['formulario']
                        ? formCheckList.estilo['cargar_tabla']['formulario']
                        : null
                      : null
                    : null,
            validations: {
              validators: [Validators.required]
            },
            size: 'col-12',
            condictions: [
              {
                campoDepende: 'cboFormMultiple',
                siEs: 'Vacio',
                accion: 'Ocultar'
              }
            ]
          }),
          new Custom({
            key: 'cboColumnMultiple',
            label: 'Columnas a mostrar:',
            template: template['ngSelectTpl'],
            placeholder: 'Seleccionar el campo del formulario',
            options: options ? options['columns'] ? options['columns'] : [] : [],
            value: formCheckList
                    ? formCheckList.estilo['cargar_tabla']
                      ? formCheckList.estilo['cargar_tabla']['column']
                        ? formCheckList.estilo['cargar_tabla']['column']
                        : null
                      : null
                    : null,
            validations: {
              validators: [Validators.required]
            },
            size: 'col-12',
            condictions: [
              {
                campoDepende: 'cboFormularioMultiple',
                siEs: 'Vacio',
                accion: 'Ocultar'
              }
            ]
          }),
          new Textbox({
            key: 'txtNombreRelacion',
            label: 'Nombre de la columna de relacion:',
            value: formCheckList
            ? formCheckList.estilo['cargar_tabla']
              ? formCheckList.estilo['cargar_tabla']['column_name']
                ? formCheckList.estilo['cargar_tabla']['column_name']
                : null
              : null
            : null,
            placeholder: 'Ingresar el nombre de la columna de relacion',
            validations: {
              validators: [Validators.required],
            },
            condictions: [
              {
                campoDepende: 'cboFormularioMultiple',
                siEs: 'Vacio',
                accion: 'Ocultar'
              }
            ],
            size: 'col-12',
          }),
          new Textbox({
            key: 'txtNombreRelacionPlaceholder',
            label: 'Placeholder de la columna de relacion:',
            value: formCheckList
            ? formCheckList.estilo['cargar_tabla']
              ? formCheckList.estilo['cargar_tabla']['column_name_placeholder']
                ? formCheckList.estilo['cargar_tabla']['column_name_placeholder']
                : null
              : null
            : null,
            placeholder: 'Ingresar el Placeholder de la columna de relacion',
            validations: {
              validators: [Validators.required],
            },
            condictions: [
              {
                campoDepende: 'cboFormularioMultiple',
                siEs: 'Vacio',
                accion: 'Ocultar'
              }
            ],
            size: 'col-12',
          })
        ]
      }),
    ];

    return controls;
  }

  /**
   * Formatea la data de la lista de maestras para mostrar en el select
   *
   * @param {Array<TablaMaestra>} masterTables
   * @returns {Array<any>}
   * @memberof CheckListFormsService
   */
  setMasterTables(masterTables: Array<TablaMaestra>): Array<any> {
    const masterT: Array<any> = [];
    masterTables.forEach(mt => {
      masterT.push({
        key: mt.id,
        value: mt.nombre
      });
    });
    return masterT;
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/check-list/shared/check-list.forms.service.ts